import React from 'react'
import {PIMStack} from '../../../Atoms/Layouts/Bases/PIMStack'
import {MBContentSubTitleTypography} from '../../../Atoms/Typographies'
import {MBRequiredBadge} from '../../../Atoms/Badges'
import {PIMWarningMessages} from '../../../Atoms/Labels/PIMWarningMessages'
import {MBMemberRadio} from '../../../Atoms/MBMemberRadio'
import {GENDER} from '../../../../../Common/Constants'

type GenderInputProps = {
  inputGender: string
  genderErrors: string[]
  onChange: (gender: string) => void
}
export const GenderInput: React.VFC<GenderInputProps> = (
  {
    inputGender,
    genderErrors,
    onChange,
  },
) => {
  return (
    <PIMStack spacing={'10px'} testId={'block-input-gender'}>
      <PIMStack direction={'row'} alignItems={'center'} spacing={'6px'}>
        <MBContentSubTitleTypography>性別</MBContentSubTitleTypography>
        <MBRequiredBadge/>
      </PIMStack>
      <PIMStack direction={'row'} spacing={3}>
        {Object.entries(GENDER).map(([value, label]) => (
          <MBMemberRadio
            key={value}
            name={'gender'}
            labelName={label}
            autoComplete={'sex'}
            value={value}
            checked={inputGender === value}
            hasError={genderErrors.length > 0}
            onChange={(e): void => onChange(e.target.value)}
          />
        ))}
      </PIMStack>
      {genderErrors.length > 0 && (
        <PIMWarningMessages messages={genderErrors}/>
      )}
    </PIMStack>
  )
}
